import { map, Observable, of} from "rxjs";
import { ajax } from "rxjs/ajax";
import { SocialMedia } from "./App";
import Cms from "./guest/Cms";
import { Faq } from "./guest/Faq";
import { ContactUs, Login, EmailVerify, Account, StockData } from "./Models";
import { GlobalContext } from './ContextProvider';

const hostName = window.location.hostname || window.location.host;

const isPublic = (hostName === 'qualitymore.com' || hostName === 'admin.qualitymore.com');
const apiEndPoint = isPublic ? 'https://api.qualitymore.com' : `${window.location.protocol}//api.qualitymore.lab`;

const setUserInfoToLocal = (userInfo: UserInfo | null): void => {
  if(userInfo) {
    localStorage.setItem('_qm-login-info', JSON.stringify(userInfo as UserInfo));
  } else {
    localStorage.removeItem('_qm-login-info');
  }
};

const getUserInfoFromLocal = (): UserInfo => {
    return JSON.parse(
        localStorage.getItem('_qm-login-info') || '{}'
      ) as UserInfo;
};

const loginHeaders = (contentType) => {
    const userInfo = getUserInfoFromLocal() as UserInfo;
    const headers: Record<string, string> = {};

    if(contentType) {
        headers["Content-Type"] = 'application/json';
    }

    if (userInfo?._qm_server_token) {
        headers["Authorization"] = `Bearer ${userInfo._qm_server_token}`;
    }
    return headers;
}

const fetchCMS = (slug: string): Observable<Cms> => {
  return ajax.get(
    `${apiEndPoint}/cms/cms/get-by-slug/${slug}`,
    { "Content-Type": "application/json" }
  ).pipe(map((res: any) => {
    return res['response'];
  }));
};

export default fetchCMS;

const fetchFAQ = (): Observable<Faq[]> => {
  return ajax.getJSON(`${apiEndPoint}/faq/faq/read-all`);
};

const fetchSocialMedia = (): Observable<SocialMedia[]> => {
  return ajax.getJSON(`${apiEndPoint}/social-media/social-media/read-all`);
};

const sendContactUsMessage = (contactUs: ContactUs): Observable<any> => {
  return ajax.post(
      `${apiEndPoint}/contact-us/contact-us/create`,
      contactUs,
      { "Content-Type": "application/json" }
      );
};

const requestLogin = (login: Login): Observable<any> => {
  return ajax.post(
      `${apiEndPoint}/security/login`,
      login,
      { "Content-Type": "application/json" }
      );
};

const requestEmailVerify = (emailVerifyBody: EmailVerify): Observable<any> => {
  return ajax.post(
      `${apiEndPoint}/mail/verifyEmail`,
      emailVerifyBody,
      { "Content-Type": "application/json" }
      );
};

const requestCodeVerify = (codeVerifyBody: CodeVerifyBody): Observable<any> => {
  return ajax.post(
      `${apiEndPoint}/mail/verifyEmailCode`,
      codeVerifyBody,
      { "Content-Type": "application/json" }
      );
};

const requestSignUp = (account: Account): Observable<any> => {
  return ajax.post(
      `${apiEndPoint}/security/signup`,
      account,
      { "Content-Type": "application/json" }
      );
};

const fetchConfigData = (): Observable<any> => {
  return ajax.getJSON(`${apiEndPoint}/cms/config/read`);
};

const createStockData = (stockData: StockData): Observable<any> => {
  return ajax.post(
    `${apiEndPoint}/record/stock-data/create`,
    stockData,
    loginHeaders(true)
  );
};

const readStockData = (): Observable<any> => {
  return ajax.get(
    `${apiEndPoint}/record/stock-data/read`,
    loginHeaders()
  ).pipe(
      map(resp=> resp.response)
  );
};

const deleteStockData = (symbol): Observable<any> => {
  return ajax.delete(
    `${apiEndPoint}/record/stock-data/delete/${symbol}`,
    loginHeaders()
  ).pipe(
      map(resp=> resp.response)
  );
};

export {
    setUserInfoToLocal,
    getUserInfoFromLocal,
    fetchFAQ,
    fetchSocialMedia,
    sendContactUsMessage,
    requestLogin,
    requestEmailVerify,
    requestCodeVerify,
    requestSignUp,
    fetchConfigData,
    createStockData,
    readStockData,
    deleteStockData
  };

